<template>
	<header>
		<div>
			<router-link v-if="back" class="mdi mdi-arrow-left" :to="back"/>
			<a v-else class="mdi mdi-menu" @click="Store.toggleMenu()"></a>
			<span>{{ title }}</span>
			<a v-for="link in links" :key="link.key" :title="link.title" class="mdi" :class="link.icon" @click="$emit('action', link.key)"/>
			<router-link v-for="action in actions" :key="action.key" :title="action.title" class="mdi" :class="action.icon" :to="{ path: action.to, query: action.query }"/>
		</div>
		<menu v-if="tabs">
			<router-link v-for="(value, key) in tabs" :key="key" :to="{ path: value.path, query: value.query }">{{ value.label }}</router-link>
		</menu>
	</header>
</template>

<script>

import Store from "@/Store.js";

export default {
	name: "MainBar",
	props: ["title", "links", "actions", "tabs", "back"],
	emits: ["action"],
	data: () => ({
		Store,
	}),
	activated() {
		if (this.tabs) {
			document.body.classList.add("high");
		} else {
			document.body.classList.remove("high");
		}
	},
}
</script>

<style lang="scss">
header {
	box-shadow: var(--shadow-2);
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	z-index: 2;

	> div {
		background: var(--color-primary);
		line-height: 3rem;
		padding: 0 1rem;
		color: white;
		font-weight: bold;
		display: flex;
		> span {
			flex: auto;
		}
		> a {
			width: 3rem;
			text-align: center;
			font-size: 1.6rem;
			border-radius: 1.5rem;
			color: white;
			&:hover {
				background: var(--color-vibrant);
				color: inherit;
			}
		}
	}
}

header menu {
	margin: 0;
	padding: 0;
	background: var(--color-foreground);
	display: flex;
	justify-content: center;
	line-height: 2.5rem;
	text-transform: uppercase;
	font-size: .9rem;

	a {
		padding: 0 .5rem;
		cursor: pointer;
		border-style: solid;
		border-width: 0 0 2px 0;
		border-color: transparent;
		color: var(--color-text);

		&.router-link-active {
			background: var(--color-background2);
			border-color: var(--color-vibrant);
		}
	}
}

</style>
